import { render, staticRenderFns } from "./editTransfer.vue?vue&type=template&id=694da708&scoped=true"
import script from "./editTransfer.vue?vue&type=script&lang=js"
export * from "./editTransfer.vue?vue&type=script&lang=js"
import style0 from "./editTransfer.vue?vue&type=style&index=0&id=694da708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694da708",
  null
  
)

export default component.exports